import React from "react";
import { FaWhatsapp } from 'react-icons/fa';

import './WhatsAppButton.css'; // Bootstrap-compatible custom styles

const WhatsAppButton = () => {
  const handleClick = () => {
    window.open("https://wa.me/918121877077", "_blank");
  };

  return (
    <button
      className="btn btn-success whatsapp-btn"
      onClick={handleClick}
      title="Chat on WhatsApp"
    >
      <FaWhatsapp size={45} />
    </button>
  );
};

export default WhatsAppButton;
